import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ReportBase64 } from '../models/reports';
import { NotificationService } from './notification.service';
import { AuthService } from '../auth.service';
import { CommunicationBase } from '../models/communication';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  apiUrl = 'v1/reports/';
  public invoiceData = '';
  public isGeneratingReport = false;

  apiUrlv2 = 'v2/reports/'

  constructor(private http: HttpClient, private notification: NotificationService, 
              private router: Router,private authService:AuthService) { }

  private downloadFile(base64:any,fileName:any){
    // const src = `data:application/pdf;base64, ${base64}`;
    // const link = document.createElement("a")
    // link.href = src
    // link.download = fileName
    // link.click()
    // link.remove()

    // Fix For all browsers including Mobile
    var element = document.createElement('a');
    var clearUrl = base64.replace(`data:application/pdf;base64,${base64}`);
    element.setAttribute('href', 'data:application/octet-stream;base64,' + encodeURIComponent(clearUrl));
    element.setAttribute('download', fileName);
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
 
    }


  public jobCard(jobCardId: number, withRev: boolean = false) {
    return this.http.get<ReportBase64>( environment.ApiUrl() + this.apiUrlv2 + `jobcard/${jobCardId.toString()}/${withRev}`);
  }

  public openJobCard(jobCardId: number, title: string = "JOBCARD", withRev: boolean = false) {
    this.jobCard(jobCardId, withRev).subscribe(
      val => {
        let pdfWindow = window.open("", "jobcard");
        // pdfWindow!.document.title = 'testing';
        if (val.title !== undefined) title = val.title;
        pdfWindow?.focus();
        pdfWindow?.document.open();
        pdfWindow!.document.write("<title>" + title + "</title><iframe width='100%' height='100%' src='data:application/pdf;base64, " + val.content + "'></iframe>");
        //window.open("data:application/pdf;base64, " + val.content);
      }
    )
  }

  public invoice(orderId: number) {
    return this.http.get<ReportBase64>( environment.ApiUrl() + this.apiUrl + "invoice/" + orderId.toString());
  }



  public openInvoice(orderId: number, title: string = "INVOICE") {
    this.invoice(orderId).subscribe(
      val => {
        let pdfWindow = window.open("",'invoice');
        if (val.title !== undefined) title = val.title;
        pdfWindow?.focus();
        pdfWindow?.document.open();
        pdfWindow!.document.write("<title>" + title + "</title><iframe width='100%' height='100%' src='data:application/pdf;base64, " + val.content + "'></iframe>");
        //window.open("data:application/pdf;base64, " + val.content);
        // this.invoiceData = val.content;
        // this.router.navigate(['sales/invoice'])
      }
    )
  }

  public downloadInvoice(orderId: number) {
    this.invoice(orderId).subscribe(
      val => {
        this.downloadFile(val.content, val.filename);
       
      }
    )
  }

  public leadsReport(userId: number){
    return this.http.get<ReportBase64>( environment.ApiUrl() + this.apiUrl + "leads_report/" + userId.toString());
  }

  public openLeadsReport(userId: number, reportBase : CommunicationBase, title: string = "Leads Report") {
    this.leadsReport(userId).subscribe(
      val => {
        if (val === null) {
          this.notification.showError("No data found for the selected user");
          return;
        }
        let pdfWindow = window.open("",'leads_report');
        if (val.filename !== undefined) title = val.filename;
        pdfWindow?.focus();
        pdfWindow?.document.open();
        pdfWindow!.document.write("<title>" + title + "</title><iframe width='100%' height='100%' src='data:application/pdf;base64, " + val.content + "'></iframe>");

      }
    )
  }

  public downloadLeadsReport(userId: number, reportBase : CommunicationBase) {
    this.leadsReport(userId).subscribe(
      val => {
        this.downloadFile(val.content, val.filename);
      }
    )
  }

  
  public quote(quoteId: number) {
    return this.http.get<ReportBase64>( environment.ApiUrl() + this.apiUrlv2 + "quote/" + quoteId.toString());
  }

  public openQuote(quoteId: number, reportBase : CommunicationBase, title: string = "QUOTE") {
    reportBase.isLoading = true;
    this.quote(quoteId).subscribe(
      val => {
        let pdfWindow = window.open("",'invoice');
        if (val.title !== undefined) title = val.title;
        pdfWindow?.focus();
        pdfWindow?.document.open();
        pdfWindow!.document.write("<title>" + title + "</title><iframe width='100%' height='100%' src='data:application/pdf;base64, " + val.content + "'></iframe>");
        //window.open("data:application/pdf;base64, " + val.content);
        // this.invoiceData = val.content;
        // this.router.navigate(['sales/invoice'])
        reportBase.isLoading = false;
      }
    )
  }

  public downloadQuote(quoteId: number, reportBase : CommunicationBase) {
    reportBase.isLoading = true;
    this.quote(quoteId).subscribe(
      val => {
        this.downloadFile(val.content, val.filename);
        reportBase.isLoading = false;
      }
    )
  }

  public salesErrorReport(dayRange:number){
    return this.http.get<ReportBase64>( environment.ApiUrl() + this.apiUrl + "salesError_report/" + dayRange);
  }

  public openSalesErrorReport(dayRange: number, reportBase : CommunicationBase, title: string = "Sales Error Report") {
    this.salesErrorReport(dayRange).subscribe(
      val => {
        if (val === null) {
          this.notification.showError("No data found for the selected user");
          return;
        }
        let pdfWindow = window.open("",'sales_error_report');
        if (val.filename !== undefined) title = val.filename;
        pdfWindow?.focus();
        pdfWindow?.document.open();
        pdfWindow!.document.write("<title>" + title + "</title><iframe width='100%' height='100%' src='data:application/pdf;base64, " + val.content + "'></iframe>");

      }
    )
  }

  public downloadSalesErrorReport(dayRange: number, reportBase : CommunicationBase) {
    this.salesErrorReport(dayRange).subscribe(
      val => {
        this.downloadFile(val.content, val.filename);
      }
    )
  }

  public document(documentId: number) {
    return this.http.get<ReportBase64>( environment.ApiUrl() + this.apiUrlv2 + "special_price_doc/" + documentId.toString());
  }
  
  public openDocument(documentId: number, title: string = "Document") {
    this.document(documentId).subscribe(
      val => {
        let pdfWindow = window.open("",'document');
        if (val.title !== undefined) title = val.title;
        pdfWindow?.focus();
        pdfWindow?.document.open();
        pdfWindow!.document.write("<title>" + title + "</title><iframe width='100%' height='100%' src='data:application/pdf;base64, " + val.content + "'></iframe>");
      }
    )
  }

  public openDocumentPopup(documentId: number, title: string = "Document") {
    //0 = Normal Pricing, it will never have a document. Also the API will return a 401 Aunauthorised, so the user will be logged out
    if (documentId > 0) {
      
      this.document(documentId).subscribe({next:
        val => {
          if (val && val.content) {
            // Remove the Base64 prefix if present
            const cleanBase64 = val.content.replace(/^data:application\/pdf;base64,/, '');
            
            // Convert Base64 to binary
            const binaryString = atob(cleanBase64);
            const bytes = new Uint8Array(binaryString.length);
            
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
          
            // Create Blob
            const blob = new Blob([bytes], { type: 'application/pdf' }); // Specify the MIME type for PDF. This can be adjusted based on the actual content type.
            const blobUrl = URL.createObjectURL(blob);
            
            // Open in new window
            const newWindow = window.open(blobUrl, '_blank', 'popupWindow,width=1200,height=800,left=-1000,top=-1000');
            
            // Clean up the URL when the window is closed
            newWindow!.onbeforeunload = function() {
              URL.revokeObjectURL(blobUrl);
            };
          }
        }
      , error: (_) => {}})
    }
  }

  public Cin7Invoice(orderId:number){
    return this.http.get<ReportBase64>( environment.ApiUrl() + this.apiUrl + "cin7_invoice/" + orderId);
  }

  public openCin7Invoice(orderId: number, reportBase : CommunicationBase, title: string = "Cin7 Invoice") {
    this.Cin7Invoice(orderId).subscribe(
      val => {
        reportBase.isLoading = false;
        if (val === null) {
          this.notification.showWarning("This order may not be invoiced yet");
          return;
        }
        let pdfWindow = window.open("",'cin7_invoice');
        if (val.filename !== undefined) title = val.filename;
        pdfWindow?.focus();
        pdfWindow?.document.open();
        pdfWindow!.document.write("<title>" + title + "</title><iframe width='100%' height='100%' src='data:application/pdf;base64, " + val.content + "'></iframe>");

      }
    )
  }

  public downloadCin7Invoice(orderId: number, reportBase : CommunicationBase) {
    this.Cin7Invoice(orderId).subscribe(
      val => {
        if (val === null) {
          this.notification.showWarning("This order may not be invoiced yet");
          return;
        }
        reportBase.isLoading = false;
        this.downloadFile(val.content, val.filename);
      }
    )
  }
}


